import _classCallCheck from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits"; //@ts-check

import React, { Component } from 'react';
import TreeModel from './model';
import TreeNode from './TreeNode';
import './react-ui-tree.css';
/**
 * @typedef {object} TreeChild
 * @property {any} [isNodeCollapsed] 
 * @property {any} [renderNode] 
 * @property {any} [changeNodeCollapsed] 
 * @property {any} [updateNodesPosition] 
 * @property {any} [getIndex] 
 * @property {any} [move] 
 * @property {any} [getNodeByTop] 
 * @property {any} [obj] 
 * @typedef  {import('../../../node_modules/js-tree/dist/tree') & TreeChild} CustomTree
 * @extends  {React.Component<import('./types').TreeProps> } 
 */

var Tree =
/*#__PURE__*/
function (_Component) {
  _inherits(Tree, _Component);

  function Tree(_props) {
    var _this;

    _classCallCheck(this, Tree);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Tree).call(this, _props));

    _this.init = function (props) {
      /** @type {CustomTree} */
      var tree = new TreeModel(props.tree);
      tree.isNodeCollapsed = props.isNodeCollapsed;
      tree.renderNode = props.renderNode;
      tree.changeNodeCollapsed = props.changeNodeCollapsed;
      tree.updateNodesPosition();
      return {
        tree: tree,
        dragging: {
          id: null,
          x: null,
          y: null,
          w: null,
          h: null
        }
      };
    };

    _this.getDraggingDom = function () {
      var _this$state = _this.state,
          tree = _this$state.tree,
          dragging = _this$state.dragging;

      if (dragging && dragging.id) {
        var draggingIndex = tree.getIndex(dragging.id);
        var draggingStyles = {
          top: dragging.y,
          left: dragging.x,
          width: dragging.w
        };
        return React.createElement("div", {
          className: "m-draggable",
          style: draggingStyles
        }, React.createElement(TreeNode, {
          tree: tree,
          index: draggingIndex,
          paddingLeft: _this.props.paddingLeft
        }));
      }

      return null;
    };

    _this.dragStart = function (id, dom, e) {
      _this.dragging = {
        id: id,
        w: dom.offsetWidth,
        h: dom.offsetHeight,
        x: dom.offsetLeft,
        y: dom.offsetTop
      };
      _this._startX = dom.offsetLeft;
      _this._startY = dom.offsetTop;
      _this._offsetX = e.clientX;
      _this._offsetY = e.clientY;
      _this._start = true;
      window.addEventListener('mousemove', _this.drag);
      window.addEventListener('mouseup', _this.dragEnd);
    };

    _this.drag = function (e) {
      if (_this._start) {
        _this.setState({
          dragging: _this.dragging
        });

        _this._start = false;
      }

      var tree = _this.state.tree;
      var dragging = _this.state.dragging;
      var paddingLeft = _this.props.paddingLeft;
      var newIndex = null;
      var index = tree.getIndex(dragging.id);
      var collapsed = index.node.collapsed;
      var _startX = _this._startX;
      var _startY = _this._startY;
      var _offsetX = _this._offsetX;
      var _offsetY = _this._offsetY;
      var pos = {
        x: _startX + e.clientX - _offsetX,
        y: _startY + e.clientY - _offsetY
      };
      dragging.x = pos.x;
      dragging.y = pos.y;
      var diffX = dragging.x - paddingLeft / 2 - (index.left - 2) * paddingLeft;
      var diffY = dragging.y - dragging.h / 2 - (index.top - 2) * dragging.h;

      if (diffX < 0) {
        // left
        if (index.parent && !index.next) newIndex = tree.move(index.id, index.parent, 'after');
      } else if (diffX > paddingLeft) {
        // right
        if (index.prev) {
          var prevNode = tree.getIndex(index.prev).node;
          if (!prevNode.collapsed && !prevNode.leaf) newIndex = tree.move(index.id, index.prev, 'append');
        }
      }

      if (newIndex) {
        index = newIndex;
        newIndex.node.collapsed = collapsed;
        dragging.id = newIndex.id;
      }

      if (diffY < 0) {
        // up
        var above = tree.getNodeByTop(index.top - 1);
        newIndex = tree.move(index.id, above.id, 'before');
      } else if (diffY > dragging.h) {
        // down
        if (index.next) {
          var below = tree.getIndex(index.next);
          if (below.children && below.children.length && !below.node.collapsed) newIndex = tree.move(index.id, index.next, 'prepend');else newIndex = tree.move(index.id, index.next, 'after');
        } else {
          var _below = tree.getNodeByTop(index.top + index.height);

          if (_below && _below.parent !== index.id) {
            if (_below.children && _below.children.length && !_below.node.collapsed) newIndex = tree.move(index.id, _below.id, 'prepend');else newIndex = tree.move(index.id, _below.id, 'after');
          }
        }
      }

      if (newIndex) {
        newIndex.node.collapsed = collapsed;
        dragging.id = newIndex.id;
      }

      _this.setState({
        tree: tree,
        dragging: dragging
      });
    };

    _this.dragEnd = function () {
      _this.setState({
        dragging: {
          id: null,
          x: null,
          y: null,
          w: null,
          h: null
        }
      });

      _this.change(_this.state.tree);

      window.removeEventListener('mousemove', _this.drag);
      window.removeEventListener('mouseup', _this.dragEnd);
    };

    _this.change = function (tree) {
      _this._updated = true;
      if (_this.props.onChange) _this.props.onChange(tree.obj);
    };

    _this.toggleCollapse = function (nodeId) {
      var tree = _this.state.tree;
      var index = tree.getIndex(nodeId);
      var node = index.node;
      node.collapsed = !node.collapsed;
      tree.updateNodesPosition();

      _this.setState({
        tree: tree
      });

      _this.change(tree);
    };

    _this.state = _this.init(_props);
    return _this;
  }

  _createClass(Tree, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (!this._updated) this.setState(this.init(nextProps));else this._updated = false;
    }
  }, {
    key: "render",
    value: function render() {
      var tree = this.state.tree;
      var dragging = this.state.dragging;
      var draggingDom = this.getDraggingDom();
      var draggable = this.props.draggable;

      if (draggable) {
        return React.createElement("div", {
          className: "m-tree"
        }, draggingDom, React.createElement(TreeNode, {
          tree: tree,
          index: tree.getIndex(1),
          key: 1,
          paddingLeft: this.props.paddingLeft,
          onDragStart: this.dragStart,
          onCollapse: this.toggleCollapse,
          dragging: dragging && dragging.id
        }));
      } else {
        return React.createElement("div", {
          className: "m-tree"
        }, React.createElement(TreeNode, {
          tree: tree,
          index: tree.getIndex(1),
          key: 1,
          paddingLeft: this.props.paddingLeft,
          onCollapse: this.toggleCollapse
        }));
      }
    }
  }]);

  return Tree;
}(Component);

Tree.defaultProps = {
  paddingLeft: 16
};
export default Tree;